import React from 'react';
import { PageHeader, Page, PageContent, Heading, Box, Text } from 'grommet';

export const FeedbackHome = () => {
  return (
    <Page flex="grow" background="transparent">
      {/* Header Section */}
      <Box background="transparent" margin={{ top: 'none' }}>
        <Box margin={{ top: 'none', left: 'large' }}>
          <PageHeader 
            pad={{ top: '0px', bottom: '40px' }} 
            title={
              <Text size="xxlarge" weight="bold" color="text-strong">
                BI Console Feedback
              </Text>
            } 
            subtitle={
              <Text size="large" color="text">
                Let's improve the console together
              </Text>
            }
            size='medium'
          />
        </Box>                  
      </Box> 

      {/* Main Content Area */}
      <PageContent flex="grow">
        <Box
          pad="xlarge"
          align="center"
          justify="center"
          round="large"
          style={{
            // Glass effect to match the rest of the console
            backgroundColor: 'rgba(255, 255, 255, 0.05)',
            backdropFilter: 'blur(12px)',
            WebkitBackdropFilter: 'blur(12px)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
          }}
        >
          <Heading 
            size="small" 
            weight="bold" 
            margin={{ top: 'none' }} 
            color="text-strong"
          >
            Coming soon...
          </Heading>
          <Text color="text" textAlign="center">
            We are building a collaborative space to gather your insights and feature requests.
          </Text>
        </Box>
      </PageContent>  
    </Page>
  );
};